import Footer from "../Footer/Footer";
import GlobalSearch from "components/GlobalSearch/GlobalSearch";
import "./style.scss";
import NavigationLeft from "components/NavigationLeft/NavigationLeft";

function Layout({ children, searchVisible, gradientFill }) {
  return (
    <div className="body-bg d-flex">
      <div className="parent-sidebar-container">
        <NavigationLeft />
      </div>
      <main className={` main-container`}>
        {searchVisible ? (
          <div className="w-100 d-block d-lg-none pt-3">
            <GlobalSearch />
          </div>
        ) : null}
        {children}
      </main>
    </div>
  );
}

export default Layout;
